import {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {stringify} from 'query-string';

import {Enums} from '_app/utils';
import SharePopoverPanel from '../SharePopoverPanel';
import SocialButton from './SocialButton';
import {getPrevPageTitle} from '_app/mediahub/mediaHubUtils';
import {userInfoShape} from '_app/shapes';
import './social-section.less';

export class SocialSection extends Component {
	constructor(props) {
		super(props);

		this.location = window.location;
		this.onStartEmail = this.onStartEmail.bind(this);
		this.onSocialShare = this.onSocialShare.bind(this);
	}

	UNSAFE_componentWillMount() {
		if (!this.props.linkObj) {
			this.props.getEmailLink();
		}

		if (!this.props.shareTexts) {
			this.props.fetchShareTexts();
		}
	}

	onStartEmail() {
		const {linkObj, location} = this.props;
		const indexOfHash = linkObj.link.indexOf('#');

		this.props.history.push({
			pathname: `/${linkObj.link.slice(indexOfHash + 1)}`,
			search: stringify({
				prevPage: getPrevPageTitle(location.pathname)
			})
		});
	}

	onSocialShare(token, type) {
		const advisorId = this.props.proxiedAs ? this.props.proxiedAs.userID : null;
		const advisorPartnerId = this.props.proxiedAs ? this.props.proxiedAs.partnerID : null;

		return this.props.addShareItem(this.props.media.ID, token, advisorId, type, advisorPartnerId);
	}

	getTitle() {
		const {allowSocial, allowEmail} = this.props;

		if (allowSocial && allowEmail) {
			return 'Share via email or social media';
		} else if (!allowSocial && allowEmail) {
			return 'Share via email';
		} else if (allowSocial && !allowEmail) {
			return 'Share via social media';
		}
		return 'Share';
	}

	getShareText(type) {
		const {shareTexts} = this.props;
		let shareTextObj;

		if (shareTexts) {
			shareTextObj = shareTexts.find(shareText => shareText.type === type);
		}

		return shareTextObj && shareTextObj.shareText || '';
	}

	render() {
		const {allowSocial, allowEmail, expanded, linkObj, expandSection} = this.props;
		const shareTypes = Enums.getType('shareTypes');

		if (!linkObj) {
			return null;
		}

		return (
			<SharePopoverPanel title={this.getTitle()} expanded={expanded} onClick={expandSection}>
				<div className="social-section-buttons">
					{allowEmail && (
						<SocialButton
							onSocialShare={this.onStartEmail}
							type={shareTypes.EMAIL}
						/>)}
					{allowSocial && (
						<SocialButton
							onSocialShare={this.onSocialShare}
							shareText={this.getShareText(shareTypes.LINKEDIN)}
							type={shareTypes.LINKEDIN}
						/>)}
					{allowSocial && (
						<SocialButton
							onSocialShare={this.onSocialShare}
							shareText={this.getShareText(shareTypes.TWITTER)}
							type={shareTypes.TWITTER}
						/>)}
					{allowSocial && (
						<SocialButton
							onSocialShare={this.onSocialShare}
							shareText={this.getShareText(shareTypes.FACEBOOK)}
							type={shareTypes.FACEBOOK}
						/>)}
				</div>
			</SharePopoverPanel>
		);
	}
}

SocialSection.propTypes = {
	media: PropTypes.object,
	expanded: PropTypes.bool,
	allowEmail: PropTypes.bool,
	allowSocial: PropTypes.bool,
	getEmailLink: PropTypes.func.isRequired,
	linkObj: PropTypes.shape({
		link: PropTypes.string,
		id: PropTypes.number,
		version: PropTypes.number
	}),
	proxiedAs: userInfoShape,
	expandSection: PropTypes.func.isRequired,
	addShareItem: PropTypes.func.isRequired,
	shareTexts: PropTypes.array
};

SocialSection.defaultProps = {
	expanded: false
};

export default withRouter(SocialSection);